import axios from 'axios'
import * as type from '../types/'

export default class ApiService {
  static API_PATH = process.env.VUE_APP_API_PATH
  static API_KEY = process.env.VUE_APP_API_KEY

  getActressList = async () => {
    try {
      const headers = {
        'x-api-key': ApiService.API_KEY ?? ''
      }
      return await axios.get(ApiService.API_PATH + 'get', { headers: headers })
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.log('error', err.response)
        return err.response
      }
      return err
    }
  }

  getVoteInfo = async (userId: string, token: string) => {
    try {
      const data = JSON.stringify({
        userId: userId,
        idToken: token
      })
      const headers = {
        'x-api-key': ApiService.API_KEY ?? '',
        'Content-Type': 'application/json'
      }
      return await axios.post(ApiService.API_PATH + 'get_vote_info', data, {
        method: 'post',
        headers: headers,
        data: data
      })
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.log('error', err.response)
        return err.response
      }
      return err
    }
  }

  vote = async (userId: string, votes: type.Vote, token: string) => {
    try {
      console.log(votes)
      const data = JSON.stringify({
        userId: userId,
        vote1: votes.vote1,
        vote2: votes.vote2,
        vote3: votes.vote3,
        vote4: votes.vote4,
        idToken: token
      })
      const headers = {
        'x-api-key': ApiService.API_KEY ?? '',
        'Content-Type': 'application/json'
      }
      return await axios.post(ApiService.API_PATH + 'vote', data, {
        method: 'post',
        headers: headers,
        data: data
      })
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.log('error', err.response)
        return err.response
      }
      return err
    }
  }

  set = async (userId: string, actressId: string, voteNum: number) => {
    try {
      const params = {
        userId: userId,
        actressId: actressId,
        voteNum: voteNum
      }
      const headers = {
        accept: 'application/json',
        'Content-Type': 'text/plain'
      }
      return await axios.post(ApiService.API_PATH + 'set', params, { headers: headers })
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.log('error', err.response)
        return err.response
      }
      return err
    }
  }

  setUserAttribute = async (userId: string, gender: string, age: string, address: string, token: string) => {
    try {
      const params = {
        userId: userId,
        gender: gender,
        age: age,
        address: address,
        idToken: token
      }
      const headersObj = {
        'x-api-key': ApiService.API_KEY ?? '',
        accept: 'application/json',
        'Content-Type': 'text/plain'
      }
      return await axios.post(ApiService.API_PATH + 'set_user_attribute', params, { headers: headersObj })
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.log('error', err.response)
        return err.response
      }
      return err
    }
  }
}
